import React from 'react';
import ErrorHandlingService from '../services/notifications/errorHandlingService';
import { t } from '../i18n/languageStore.js';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to our centralized error handling service
    ErrorHandlingService.handleError(error, 'ERROR_BOUNDARY', {
      componentStack: errorInfo.componentStack,
      errorBoundary: true
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full mx-4">
            <div className="text-center">
              <div className="text-red-500 text-6xl mb-4">⚠️</div>
              <h1 className="text-2xl font-bold text-gray-800 mb-4">
                {t('errorBoundary.title', { ns: 'common' })}
              </h1>
              <p className="text-gray-600 mb-6">
                {t('errorBoundary.description', { ns: 'common' })}
              </p>
              <div className="bg-gray-50 p-4 rounded-md mb-6">
                <p className="text-sm text-gray-700 font-mono">
                  {this.state.error?.toString()}
                </p>
              </div>
              <button
                onClick={() => window.location.reload()}
                className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md transition-colors"
              >
                {t('errorBoundary.reloadPage', { ns: 'common' })}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
